import { render, staticRenderFns } from "./CanvasShareDialog.vue?vue&type=template&id=4b300ce1&scoped=true"
import script from "./CanvasShareDialog.vue?vue&type=script&lang=js"
export * from "./CanvasShareDialog.vue?vue&type=script&lang=js"
import style0 from "./CanvasShareDialog.vue?vue&type=style&index=0&id=4b300ce1&prod&scoped=true&lang=scss"
import style1 from "./CanvasShareDialog.vue?vue&type=style&index=1&id=4b300ce1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b300ce1",
  null
  
)

export default component.exports